<template>
  <div>
    <div class="f-link">
      <div class="f-l-cont">
        <div class="f-l-icon">
          <a target="_blank" href="https://discord.gg/p7QCHPntuf">
            <img src="/static/img/1.png" />
          </a>
          <a target="_blank" href="https://twitter.com/DigitalHunterCN">
            <img src="/static/img/2.png" />
          </a>
          <a target="_blank" href="https://www.youtube.com/@DigitalHunter2023">
            <img src="/static/img/3.png" />
          </a>
          <a href="https://space.bilibili.com/96909396">
            <img src="/static/img/4.png" />
          </a>
          <!-- <a>
              <img src="/static/img/5.png" />
          </a>-->
        </div>
        <div style="height:57px"></div>
        <p>本站只提供游戏资讯，不做任何投资建议</p>
        <p>健康游戏忠告：抵制不良游戏，拒绝盗版游戏！注意自我保护，谨防受骗上当！适度游戏益脑，沉迷游戏伤身！合理安排时间，享受健康生活！</p>
        <div class="f-code">
          <img src="/static/img/qrcode.jpg" />
          <p>扫一扫关注公众号</p>
        </div>
      </div>
    </div>
    <div class="footer">CopyRight @ 1999-2023 ALi213.Met All Right Reserved 数字猎人版权所有</div>
  </div>
</template>
<script>

export default {
  name: 'Header',
  data () {
    return {}
  },
  methods: {
    // login(){
    //   console.log(111)
    // }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.f-link {
  max-width: 1920px;
  height: 230px;
  background: #363d4e;

  .f-l-cont {
    width: 1518px;
    margin: 0 auto;
    padding-top: 40px;
    position: relative;
    .f-l-icon {
      overflow: hidden;
      a {
        float: left;
        width: 40px;
        height: 40px;
        margin-right: 16px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    p {
      color: white;
      opacity: 0.3;
    }
  }
}
.f-code {
  position: absolute;
  right: 0;
  top: 46px;
  img {
    width: 120px;
    height: 120px;
  }
}
.footer {
  height: 42px;
  line-height: 42px;
  color: rgba(255, 255, 255, 0.5);
  background: #272b33;
  text-align: center;
  letter-spacing: 1px;
  font-size: 14px;
  position: relative;
}
</style>
